import React, { useRef, useState, useEffect } from 'react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { DataScroller } from 'primereact/datascroller';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { PrintTrip } from '../PrintTrip';
import { useReactToPrint } from 'react-to-print';
import axiosInterceptor from '../../AuthIntercept';
import axios from 'axios'
import useGlobalState, { g_user, API_Root } from "../../globalState";
import { Calendar } from 'primereact/calendar';
import { renderTripRoute } from './tripRoute';
import { ListLoading } from '../ListLoading';

export const TripHistory = () => {
   const [trips, setTrips] = useState([]);
   const [loading, setLoading] = useState(true);
   const [showPrint, setShowPrint] = useState(false);
   const [tripToPrint, setTripToPrint] = useState();
   const [dealerships, setDealerships] = useState(undefined);
   const [curDealership, setCurDealership] = useState(undefined);
   const [init, setInit] = useState(false);
   const [user,] = useGlobalState(g_user);
   const printRef = useRef(null);
   const [viewDate, setViewDate] = useState();

   const handlePrint = useReactToPrint({
      content: () => printRef.current,
   });

   const getDealerships = () => {
      var dealerArr = [];

      user.adminDealerships.forEach((d) => {
         dealerArr.push({ id: d.id, name: d.dealershipName, admin: true, porter: false });
      });

      user.porterDealerships.forEach((d) => {
         var match = undefined;
         dealerArr.forEach((a) => {
            if (a.id === d.id) {
               match = a;
            }
         });

         if (match !== undefined) {
            match.porter = true;
         } else {
            dealerArr.push({ id: d.id, name: d.dealershipName, admin: false, porter: true });
         }
      });

      setDealerships(dealerArr);
      if (dealerArr.length > 0) {
         setCurDealership(dealerArr[0]);
      } else {
         setLoading(false);
      }
   }

   useEffect(() => {
      if (!init) {
         setInit(true);
         setViewDate(new Date);
         getDealerships();
      }
   }, []);

   useEffect(() => {
      if (curDealership && viewDate) {
         getTripsForDealership(curDealership.id);
      }
   }, [curDealership, viewDate]);

   const getDealershipDropdown = () => {
      if (dealerships !== undefined && dealerships.length === 1) {
         return <div className="text-lg md:text-3xl">Trips For {dealerships[0].name}</div>;
      }
      else if (dealerships !== undefined && dealerships.length > 1) {
         return <div className="grid">
            <div className="col-12 md:col-3 text-left md:text-right mr-3 mt-2">
               <label htmlFor="dealerships">Trips For</label>
            </div>
            <div className="col-12 md:col-8">
               <Dropdown value={curDealership} onChange={(e) => selectDealership(e.value)} options={dealerships} optionLabel="name"
                  placeholder="Select a dealership" className="w-full" />
            </div>
         </div>;
      }
      else {
         return <div></div>;
      }
   }

   const selectDealership = (sel) => {
      setCurDealership(sel);
   }

   
   const getTripsForDealership = (id) => {
      let dt = new Date();
      if (viewDate) {
         dt = viewDate;
      }

      setLoading(true);
      var apiUrl = `${API_Root}api/trip/GetHistoryForDealership?id=${id}&month=${dt.getMonth()}&year=${dt.getFullYear()}`;
      axios.get(apiUrl).then((values) => {
         setTrips(values.data || []);
      }).catch(() => {
         setTrips([]);
      }).finally(() => {
         setLoading(false);
      });
   }

   const routeTemplate = (rowData) => {
      return (
        <div className="w-full text-center job-card-route">{renderTripRoute(rowData, rowData.TripVehicles)}</div>
      );
   };

    const printTrip = (t) => {
      setTripToPrint(t);
      setShowPrint(true);
   }

   const requestedDateTimeTemplate = (rowData) => {
      var d = new Date(rowData.requestedDeliveryDateTime);
      var formattedDate = d.toLocaleDateString('en-US', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
      let cnt = rowData.TripVehicles.length;
      let pickupLabel = null;
      if (rowData.pickupDateTime) {
         pickupLabel = new Date(rowData.pickupDateTime).toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
         });
      }

      return (
         <div className="">
            <div className="w-full font-bold">{formattedDate} - {cnt} vehicles</div>
            {pickupLabel ? (
               <div className="w-full text-sm text-color-secondary mt-1">Pickup available {pickupLabel}</div>
            ) : null}
         </div>
      );

   };

   const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
   });

   const costTemplate = (rowData) => {
      let total = rowData.ExpenseCost + rowData.MileageCost;

      return (
         <div className="w-full">
            <div className="w-full text-center">
               <div className="w-full font-bold">{formatter.format(total)}</div>
            </div>
         </div>
      );
   };

   const actionTemplate = (rowData) => {

      return (
         <div className="w-full">
            <div className="w-full text-right">
               <Button className="p-2" icon="pi pi-print" link onClick={() => printTrip(rowData)} />
            </div>
         </div>
      );
   };

   const addButtonTemplate = () => {
      return <Calendar className="mr-3" value={viewDate} onChange={(e) => setViewDate(e.value)} view="month" dateFormat="MM yy" />;
   }

   const itemTemplate = (item) => {
      return <div className="flex justify-content-between flex-wrap flex-column xl:flex-row xl:align-items-start p-4 gap-4">
         <div>
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Delivery date</span>
            {requestedDateTimeTemplate(item)}
         </div>
         <div>
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Route</span>
            {routeTemplate(item)}
         </div>
         <div>
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Cost</span>
            {costTemplate(item)}
         </div>
         <div>
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Actions</span>
            {actionTemplate(item)}
         </div>

      </div>
   }

   //<Column header="Status" style={{ minWidth: '12rem' }} body={statusTemplate} />
   return (
      <>
         <ConfirmDialog />
         <div className="card">
            <div className="grid mt-2 ml-2">
               <div className="col-12 md:col-6">
                  {getDealershipDropdown()}
               </div>
               <div className="col-12 md:col-6 text-left md:text-right">
                  {addButtonTemplate()}
               </div>
            </div>
            <div className="card">
               {loading ? (
                  <ListLoading message="Loading delivery history…" />
               ) : trips.length === 0 ? (
                  <div className="jobs-empty">
                     <i className="pi pi-calendar text-5xl mb-3"></i>
                     <h3>No completed deliveries</h3>
                     <p>Finished trips for this month will show up here.</p>
                  </div>
               ) : (
                  <DataScroller value={trips} itemTemplate={itemTemplate} rows={30} buffer={0.4} header="" />
               )}
            </div>
         </div>
         <Dialog header="Print Trip" visible={showPrint} style={{ width: '65vw' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} onHide={() => setShowPrint(false)}>
            <div className="w-full text-right mt-2"><Button className="p-2" label="Print" icon="pi pi-print" onClick={() => handlePrint()} /></div>
            <PrintTrip ref={printRef} trip={tripToPrint} dealer={curDealership}></PrintTrip>
         </Dialog>
      </>
   );
}